import { Skeleton, Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type INavigationRailSectionItemSkeletonProps = IContainerProps;

const styles = stylex.create({
  host: {
    height: 52,
  },
  icon: {
    width: 24,
    height: 24,
  },
});

export const NavigationRailSectionItemSkeleton: React.FC = () => (
  <Stack align="center" justify="center" gap={2} sx={styles.host}>
    <Skeleton sx={styles.icon} />
    <Skeleton
      length={{
        min: 4,
        max: 10,
      }}
    />
  </Stack>
);
